<template>
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="代码管理" name="codemanager"></el-tab-pane>
      <el-tab-pane label="体验者管理" name="testermanager"></el-tab-pane>
    </el-tabs>

    <CodeManager v-if="activeName == 'codemanager'"></CodeManager>
    <!--体验者列表-->
    <TesterManager v-if="activeName == 'testermanager'"></TesterManager>
  </div>
</template>
<script>
import CodeManager from './codemanager/index.vue';
import TesterManager from './testermanager/index.vue';

export default {
  components: {
    CodeManager,
    TesterManager,
  },
  data() {
    return {
      /*当前选中*/
      activeName: 'codemanager'
    };
  },
  methods: {}
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/plus/port/manager/index.vue